export default __webpack_public_path__ + "img/dUSAsnXk.3297f4cb.svg";